/**
 * Defines the cloud region of the API domains.
 *
 * @public
 */
export enum CloudRegion {
  US = 'us',
  EU = 'eu',
}